import { render } from "./FilaFolhetosTable.vue?vue&type=template&id=23516931&scoped=true"
import script from "./FilaFolhetosTable.vue?vue&type=script&lang=js"
export * from "./FilaFolhetosTable.vue?vue&type=script&lang=js"

import "./FilaFolhetosTable.vue?vue&type=style&index=0&id=23516931&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23516931"]])

export default __exports__